import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { usePublicCityLinks } from "../../lib/werkgebied";

export const ServiceArea = () => {
  const cities = usePublicCityLinks();
  return (
  <section aria-labelledby="werkgebied-title" className="section border-t border-slate-200 bg-slate-50" data-testid="home-service-area">
    <div className="container-tight grid gap-8 lg:grid-cols-12 lg:gap-12">
      <div className="relative overflow-hidden rounded-3xl bg-ink p-8 text-white sm:p-10 lg:col-span-5">
        <div className="hero-grid-dark absolute inset-0 opacity-60" aria-hidden="true" />
        <div className="relative">
          <p className="eyebrow !text-[#D9B97A]">Werkgebied</p>
          <h2 id="werkgebied-title" className="h2 mt-3 !text-white">Gevestigd in Maassluis, actief in heel Zuid-Holland</h2>
          <p className="mt-4 leading-relaxed text-slate-300">
            Vanuit Maassluis zijn we snel ter plaatse in de Waterweg-regio, het Westland, Rotterdam, Delft en Den Haag.
            We kennen de woningen in de regio — van jaren-30 woningen tot rijwoningen uit de jaren 70 en 80.
          </p>
          {cities.some((c) => c.slug === "maassluis") && <Link to="/kunststof-kozijnen-maassluis" data-testid="home-city-maassluis"
            className="mt-8 inline-flex items-center gap-2 font-semibold text-white underline-offset-4 hover:underline">
            Kozijnen in Maassluis <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>}
        </div>
      </div>
      <div className="lg:col-span-7">
        <h3 className="text-[13px] font-semibold uppercase tracking-[0.14em] text-slate-500">Lokale informatie per plaats</h3>
        <ul className="mt-5 grid grid-cols-2 gap-2.5 sm:grid-cols-3 sm:gap-3">
          {cities.filter((c) => c.slug !== "maassluis").map((c) => (
            <li key={c.slug}>
              <Link to={`/kunststof-kozijnen-${c.slug}`} data-testid={`home-city-${c.slug}`}
                className="group flex min-h-[52px] items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-3 text-[14px] sm:gap-2.5 sm:px-4 sm:text-[14.5px] font-semibold text-ink transition-[border-color,transform] duration-200 hover:-translate-y-0.5 hover:border-maas">
                <MapPin className="h-4 w-4 shrink-0 text-maas" aria-hidden="true" />
                <span className="flex-1">{c.name}</span>
                <ArrowRight className="hidden h-4 w-4 shrink-0 text-slate-300 transition-colors group-hover:text-maas sm:block" aria-hidden="true" />
              </Link>
            </li>
          ))}
        </ul>
        <Link to="/werkgebied" className="btn-ghost -ml-3 mt-6" data-testid="home-werkgebied-link">
          Bekijk het hele werkgebied <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      </div>
    </div>
  </section>
  );
};
